import { Cookies } from 'quasar';

export const cookiesStorage = {
  getItem(key) {
    return Cookies.get(key);
  },
  setItem(key, value) {
    Cookies.set(key, value, {
      secure: process.env.NODE_ENV === 'production',
      path: '/',
      sameSite: 'Strict',
    });
  },
};
